import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-submit-loader',
  templateUrl: './submit-loader.component.html',
  styleUrls: ['./submit-loader.component.scss']
})
export class SubmitLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
